<template>
  <div class="about">
    <!-- <h1>Registered pilots</h1> -->
    <AddMsg></AddMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import AddMsg from '@/components/airbox/AddMsg.vue'

export default {
  name: 'Lsb',
  data () {
    return {
      startInput: 0
    }
  },
  components: {
    AddMsg
  }
}
</script>